module.exports = {
  baseSiteUrl: "https://www.crunchyroll.com",
  baseNewsSiteUrl: "https://www.crunchyroll.com/news",
  baseSsoUrl: "https://sso.crunchyroll.com",
  baseStaticUrl: "https://static.crunchyroll.com",
  cxApiParams: {
    host: "https://www.crunchyroll.com",
    accountAuthClientId: "opy75pstrnzw4edkr9ed",
  },
  newsApiParams: {
    baseUrl: "https://cr-news-api-service.prd.crunchyrollsvc.com/v1",
  },
  datadog: {
    env: "prod",
  },
  analytics: {
    writeKey: "VfZ36W4IeP9eT1VqeGPX2DIwq6SeLyW4",
  },
  features: {
    storageKey: "efg_state",
  },
  oneTrust: null,
};
